import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "body2-text font-weight-regular text-black pa-0" };
const _hoisted_2 = { class: "body2-text font-weight-regular text-black pa-0 justify-end" };
const _hoisted_3 = { class: "text-right body2-text font-weight-regular text-black pa-0 justify-end" };
const _hoisted_4 = { class: "body2-text font-weight-regular pa-0" };
const _hoisted_5 = { class: "body2-text font-weight-regular pa-0 justify-end" };
const _hoisted_6 = { class: "text-right body2-text font-weight-regular pa-0 justify-end" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_col = _resolveComponent("v-col");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_list_item = _resolveComponent("v-list-item");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_list = _resolveComponent("v-list");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_card = _resolveComponent("v-card");
    return (_openBlock(), _createBlock(_component_v_card, {
        width: "340",
        elevation: "0"
    }, {
        default: _withCtx(() => [
            _createVNode(_component_v_list, {
                dense: "",
                class: "pa-0 goods-list"
            }, {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.goodsList, (goods, goodsKey) => {
                        return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: goodsKey,
                            class: "goods-list__item goods-list__goods-item"
                        }, {
                            default: _withCtx(() => [
                                _createCommentVNode(" 메뉴 "),
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "6" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_1, _toDisplayString(goods.name), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */),
                                        _createVNode(_component_v_col, { cols: "2" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info'
                                                    + '.suffix_quantity', { count: goods.count })), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */),
                                        _createVNode(_component_v_col, { cols: "4" }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.currency(goods.price)), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1024 /* DYNAMIC_SLOTS */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */),
                                _createCommentVNode(" 옵션 "),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goods.options, (option, optionKey) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: optionKey,
                                        class: "goods-list__item goods-list__option-item"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "6" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_4, " +" + _toDisplayString(option.name), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */),
                                                    _createVNode(_component_v_col, { cols: "2" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info'
                                                                + '.suffix_quantity', { count: option.count })), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */),
                                                    _createVNode(_component_v_col, { cols: "4" }, {
                                                        default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.currency(option.price)), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */));
                                }), 128 /* KEYED_FRAGMENT */)),
                                (!_ctx.isLastItem(goodsKey))
                                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                                        key: 0,
                                        class: "goods-list__item goods-list__divider-item"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_divider)
                                        ]),
                                        _: 1 /* STABLE */
                                    }))
                                    : _createCommentVNode("v-if", true)
                            ]),
                            _: 2 /* DYNAMIC */
                        }, 1024 /* DYNAMIC_SLOTS */));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
            }),
            (_ctx.goodsList.length)
                ? (_openBlock(), _createBlock(_component_v_divider, {
                    key: 0,
                    class: "mt-4"
                }))
                : _createCommentVNode("v-if", true),
            _createCommentVNode(" 총 금액 "),
            _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "pa-4",
                justify: "space-between"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-subtitle-1 font-weight-medium brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('views.order_detail.order_detail_goods_and_payment_info'
                                        + '.total_price')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "text-right wh-nw text-subtitle-1 font-weight-medium text-black pa-0 justify-end" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.currency(_ctx.amount)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }));
}
